<template>
  <div>
    <login-form :on-submit="handleSubmit" :buttonText="buttonText" />
    <p class="dash has-text-centered">&mdash; or &mdash;</p>
    <button
      @click="handleLoginWithGoogle"
      class="button is-medium is-google">
      <span class="icon">
        <i class="fab fa-google"></i>
      </span>
      <span>{{isSignUp ? 'Sign up' : 'Log in'}} with Google</span>
    </button>

    <div v-if="isSignUp" class="tc has-text-grey-light is-size-7 has-text-centered">
      By signing up, you agree to tinythoughts'
      <router-link to="/terms-and-conditions" target="_blank">Terms & Conditions</router-link> and
      <router-link to="/privacy-policy" target="_blank">Privacy Policy</router-link>.
    </div>
    <div v-if="isSignUp" class="login has-text-centered">
      Already have an account? <a @click="handleSwitchSignUp">Log in</a>
    </div>
    <div v-else class="login has-text-centered">
      Don't have an account? <a @click="handleSwitchSignUp">Sign up</a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import LoginForm from './LogInForm.vue'

export default {
  name: 'SocialLoginContainer',
  components: {
    LoginForm
  },
  props: {
    isSignUp: {
      default: false,
      type: Boolean
    },
    handleSwitchTab: {
      type: Function
    },
    line: {
      type: Object
    }
  },
  computed: {
    buttonText() {
      return this.isSignUp ? 'Sign up' : 'Log in'
    },
  },
  methods: {
    ...mapActions([
      'userEmailSignIn',
      'userEmailSignUp',
      'userGoogleSignIn'
    ]),
    handleSwitchSignUp() {
      this.handleSwitchTab(!this.isSignUp)
    },
    handleLoginWithGoogle() {
      return this.userGoogleSignIn({
        isMobile: this.$mq.isMobile(),
        line: this.line
      })
    },
    handleSubmit(user) {
      if (this.isSignUp) {
        return this.userEmailSignUp({ user, line: this.line })
      }
      return this.userEmailSignIn({ user, line: this.line });
    }
  }
}
</script>

<style scoped lang="scss">
button {
  width: 100%;
}

.dash {
  font-style: italic;
  margin: 20px;
}

.login,
.tc {
  margin-top: 20px;
}
</style>
